export enum DialogMessageType {
    INFO = 1,
    QUESTION = 2,
    WARNING = 3,
    ERROR = 4,
    SUCCESS = 5
}